import { PAGEPATHS } from "../../components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";
import ReactApexChart from 'react-apexcharts';

const VulnerabilityOverview = (props) => {
    document.title = "Vulnerability Overview";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [zaproxyTableData, setZaproxyTableData] = useState({})
    const [zaproxyTotalIssues, setZaproxyTotalIssues] = useState('')

    const [pieZaproxyOptions, setPieZaproxyOptions] = useState({
        chart: {
            type: 'donut',
        },
        title: {
            text: 'Zaproxy Scan Issue Distribution',
            align: 'center',
            style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#2c3e50',
            },
        },
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            fontFamily: 'inherit',
            itemMargin: {
                horizontal: 10,
                vertical: 8,
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                },
                expandOnClick: false,
            },
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '10px',
                fontWeight: 600,
                colors: ['#ffffff'],
            },
            dropShadow: {
                enabled: true,
                blur: 2,
                opacity: 0.45,
            },
            formatter: (val, opts) => {
                return opts.w.config.labels[opts.seriesIndex];
            },
        },
        tooltip: {
            y: {
                formatter: (val) => `${val} issues`,
            },
        },
        labels: [],
        
        responsive: [
            {
                breakpoint: 1024,
                options: {
                    chart: { height: 480 },
                    legend: { position: 'bottom', fontSize: '13px' },
                    title: { style: { fontSize: '18px' } },
                },
            },
            {
                breakpoint: 768,
                options: {
                    chart: { height: 420 },
                    legend: { position: 'bottom', fontSize: '12px' },
                    dataLabels: { enabled: false },
                    plotOptions: {
                        pie: { donut: { size: '65%' } },
                    },
                },
            },
            {
                breakpoint: 480,
                options: {
                    chart: { height: 380 },
                    legend: { fontSize: '11px' },
                    title: { style: { fontSize: '16px' } },
                },
            },
        ],
    });

    const [pieZaproxySeries, setPieZaproxySeries] = useState([]);

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Vulnerability Overview", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Vulnerability Overview", breadcrumbItems)
    })

    useEffect(() => {
        const getZaproxyData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_ZAPROXY_SCAN}/${scanId}`)
                if (data.status) {
                    data.data.tableData = data.data.tableData.map(obj => {
                        return Object.fromEntries(
                            Object.entries(obj).map(([key, value]) => [
                                key, typeof value === 'number' || typeof value === 'boolean'
                                    ? value
                                    : value === null
                                        ? 'NaN'
                                        : value
                            ])
                        );
                    });
                    const { tableData, chart, totalIssues } = data.data
                    const valid = tableData.reduce((acc, val) => {
                        if (acc.columns?.length === 0) {
                            acc.columns = Object.keys(val).reduce((a, k) => {
                                a.push({
                                    label: k,
                                    field: k,
                                    sort: 'asc',
                                    width: 150
                                })
                                return a
                            }, [])
                        }
                        acc.rows.push(val)
                        return acc
                    }, { columns: [], rows: [] })
                    setZaproxyTableData(valid)
                    setPieZaproxySeries(chart.map(c => c.count))
                    setPieZaproxyOptions((pre) => ({
                        ...pre,
                        labels: chart.map(r => r.reference)
                    }))
                    setZaproxyTotalIssues(totalIssues)
                }
            } catch (e) {
                console.error(e);
            }
        }
        getZaproxyData()
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <TableHeader scanName={"Zaproxy Scan"} scanId={scanId} />
                        <CardBody className="search-engine-table">
                            {zaproxyTableData && zaproxyTableData.rows && (
                                <DataTableWithPopup
                                    noBottomColumns={false}
                                    thirdPartyData={zaproxyTableData}
                                />
                            )}
                        </CardBody>
                    </Card>
                    <Card
                        className="flex-col md:flex-row card"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            gap: '3em',
                            padding: '2em',
                            alignItems: 'start',
                        }}
                    >
                        <Card className="w-full md:w-[30%]">
                            <TableHeader
                                customStyle={{ textAlign: 'center' }}
                                scanName={"Total Issues"}
                                scanId={null}
                            />
                            <CardBody
                                style={{
                                    textAlign: 'center',
                                    fontSize: 'xxx-large',
                                    width: '100%',
                                    alignContent: 'center',
                                    backgroundColor: 'rgb(254, 202, 202)',
                                    color: '#a70000'
                                }}
                            >
                                <span>{zaproxyTotalIssues}</span>
                            </CardBody>
                        </Card>
                        <Card className="w-full md:w-[70%]" >
                            <CardBody>
                                {pieZaproxyOptions.labels && pieZaproxySeries.length !== 0 && (
                                    <ReactApexChart
                                        options={pieZaproxyOptions}
                                        series={pieZaproxySeries}
                                        type="donut"
                                        height={600}
                                        width="100%"
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Card>
                </Col>
            </Row>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(VulnerabilityOverview)